import Skelet from '../Skelet';
import styles from '../../styles/modules/objects/ObjectsCatalogItem.module.scss';

const ObjectsCatalogItem = () => {
  return (
    <div className={styles.item}>
      <div className={styles.itemGallery}>
        <Skelet
          style={{ height: 'calc(100% - 4px)', width: 'auto', borderRadius: 10, margin: 2 }}
        />
      </div>
      <div className={styles.itemData}>
        <Skelet className={styles.itemPrice} height={46} maxWidth={200} />
        <Skelet className={styles.itemAddress} height={21} maxWidth={240} />
        <div className={styles.itemProperties}>
          <Skelet
            className={styles.itemProperty}
            width={60}
            height={32}
            style={{ marginRight: 12 }}
          />
          <Skelet
            className={styles.itemProperty}
            width={60}
            height={32}
            style={{ marginRight: 12 }}
          />
          <Skelet
            className={styles.itemProperty}
            width={60}
            height={32}
            style={{ marginRight: 12 }}
          />
        </div>
        <Skelet className={styles.itemDescription} height={110} />
        <div className={styles.itemActions}>
          <div className={styles.itemDate} />
          <Skelet width={150} height={50} style={{ borderRadius: 12 }} />
        </div>
      </div>
    </div>
  );
};

export default ObjectsCatalogItem;
